export default {
	"messageTemplate": {
		"templateCode": "template code",
		"templateName": "template name",
		"messageType": "message type",
		"templateContent": "template content information",
		"version": "version",
		"tabpanleName": "template information",
		"sms": "sms",
		"emailTitle": "mail title",
		"wechatMsg": "wechat enterprise group news",
		"dd": "dingding",
		"message": "information",
		"delelteWarning": "are you sure to delete this template"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/messageTemplate/messageTemplate.js